import { useMutation } from '@tanstack/react-query';

import type {
  MutationFunction,
  UpdateLineItemSettingsData,
} from '@frontend/api';
import { useRequest } from '@frontend/api';

export const useUpdateLineItemSettings: MutationFunction<
  UpdateLineItemSettingsData,
  UpdateLineItemSettingsData
> = ({ query, requestOptions, queryOptions } = {}) => {
  const urlPath = `/suppliers/quote_item_settings`;
  const request = useRequest(requestOptions);

  return useMutation((requestData) => {
    return request(urlPath, {
      query,
      init: {
        method: 'PATCH',
        body: requestData,
      },
    });
  }, queryOptions);
};
